import { render, staticRenderFns } from "./returnLog.vue?vue&type=template&id=4c4ab825"
import script from "./returnLog.vue?vue&type=script&lang=js"
export * from "./returnLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports